// this will use the default instance from i18n which should be the right one unless we use multiple instances
import i18next from 'i18next'
import type { TOptions, ThirdPartyModule, i18n } from 'i18next'

import type { TranslationKey } from './types'

let i18nInstance: i18n = i18next

const setI18n = (instance: i18n) => {
  i18nInstance = instance
}

export const t = (key: TranslationKey, args?: TOptions) => {
  return i18nInstance.t(key, args)
}

export const initFlowsI18n: ThirdPartyModule = {
  type: '3rdParty',

  init: (instance: i18n) => {
    setI18n(instance)
  },
}
